<template>
  <form v-on:submit.prevent="submitForm">

      <h2>ECommerce</h2>
      <div class="form-group"><label for="id">ID :</label><input class="form-control" id="id" readonly="readonly" v-model="eCommerce.id"/></div>
      <div class="form-group"><label for="thirdIdECommerce">Third ID ECommerce : </label><input class="form-control" id="thirdIdECommerce" v-model="eCommerce.thirdIdEcommerce"/></div>
      <div class="form-group"><label for="name">Name : </label><input class="form-control" id="name" v-model="eCommerce.name"/></div>
      <div class="form-group"><label for="typeCode">Type Code : </label><input class="form-control" id="typeCode" v-model="eCommerce.typeCode"/></div>
      <div class="form-group"><label for="begin">Begin : </label><input class="form-control" id="begin" v-model="eCommerce.begin"/></div>
      <div class="form-group"><label for="end">End : </label><input class="form-control" id="end" v-model="eCommerce.end"/></div>
      <div class="form-group" v-if="!isCountryNull(eCommerce)"><label for="countryCode">Country : </label>
        <input class="form-control" id="countryCode" v-model="eCommerce.country.thirdIdCountry"/>
      </div>
      <div v-if="isCountryNull(eCommerce)">
        No country associated to this eCommerce
      </div>
      <div>
        <p>
          <input class="btn btn-edit" type="submit" value="Submit">
        </p>

        <p class="btn btn-deprecate" @click="deprecateECommerce()">
          <v-icon> mdi-clock </v-icon>
          <input class="btn" value="Deprecate">
        </p>

        <p>
          <router-link class="btn btn-cancel" v-bind:to="{path: 'eCommerces'}">
            <v-icon>mdi-cancel</v-icon>
            <input class="btn" type="submit" value="Cancel">
          </router-link>
        </p>
      </div>
    </form>
</template>

<script>
import {parameters} from "../../parameters";
import {httpClient} from "../../requesters/httpClient";

export default {
  name: 'EditEcommerce',

  async created() {
    await httpClient.get(`${parameters.posdataRefUrl}/e-commerces/` + this.$route.query.id)
      .then((response)=> {
        this.eCommerce = response.data;
      })
      .catch((error)=> {
        throw error;
      });
  },
  data() {
    return {
      eCommerce: null
    }
  },
  methods: {
    isCountryNull: function(eCommerce){
      return eCommerce.country === null;
    },
    async submitForm(e) {

      if (this.eCommerce.country != null){
        this.eCommerce.thirdIdCountry = this.eCommerce.country.thirdIdCountry;
      } else {
        this.eCommerce.thirdIdCountry = '';
      }

      await httpClient.post(`${parameters.posdataRefUrl}/overwrite/e-commerce`, this.eCommerce);

      await this.$alert("The ecommerce was overwritten THEN updated");

      await this.$router.push('ecommerces');

      e.preventDefault();
    },
    async deprecateECommerce() {
      await httpClient.post(`${parameters.posdataRefUrl}/e-commerce/` + this.eCommerce.id + `/deprecate`)
        .then(function (response) {
          if (response.status === 200) {
            alert("The ECommerce was deprecated")
          } else {
            alert("ECommerce is not present in database and can't be deprecated")
          }

        })
      await this.$router.push('ecommerces')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/eCommerces/EditECommerce.vue